<template>
  <div>
    <van-field
      v-model="val"
      :label="label"
      :placeholder="placeholder || label"
      :rules="[{ required: required, message: '请选择' + this.label }]"
      readonly
      is-link
      @click="show = true"
    />
    <van-popup v-model="show" style="width: 100%">
      <van-datetime-picker v-model="currDate" type="date" :title="'选择 ' + label"
                           @confirm="change" @cancel="show = false" />
    </van-popup>
  </div>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      val: this.value,
      currDate: this.value ? new Date(String(this.value).replace(/-/g, "/")) : new Date()
    }
  },
  watch: {
    value: function(value) {
      this.val = value
      this.currDate = new Date(String(value).replace(/-/g, "/"))
    }
  },
  methods: {
    change(value) {
      this.val = this.Utils.df(value, '{y}-{m}-{d}')
      this.$emit('change', this.val)
      this.show = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseDate.vue